var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloudSql = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-cloud-sql",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.99,
    height: 30,
    viewBox: "0 0 21.99 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M0,33.76v4.515l10.995,5.85V39.61Zm0,6.975V45.25L10.995,51.1V46.585Z",
    transform: "translate(0 -21.1)",
    fill: "#aecbfa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M29.32,44.125l10.995-5.85V33.76L29.32,39.61Zm0,6.975,10.995-5.85V40.735L29.32,46.585Z",
    transform: "translate(-18.325 -21.1)",
    fill: "#669df6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M40.315,10.365V5.85L29.32,0V4.515Z",
    transform: "translate(-18.325)",
    fill: "#4285f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M10.995,0,0,5.85v4.515l10.995-5.85Z",
    fill: "#669df6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M0,15.48v4.53l10.995,5.85V21.33Z",
    transform: "translate(0 -9.675)",
    fill: "#aecbfa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M29.32,25.86l10.995-5.85V15.48L29.32,21.33Z",
    transform: "translate(-18.325 -9.675)",
    fill: "#669df6",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloudSql);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cloudSql.b16976424683ba840529b54552d8e91a.svg";